import React, { useEffect } from 'react';
import { Faq } from 'components/faq';

export const FaqPage: React.FC = () => {
    useEffect(() => {
        document.title = 'FAQ';
    }, []);

    return <Faq />;
};
